import { useState, useEffect } from "react";

// Soft blush SVG placeholder — no model photo, neutral brand-aligned.
const PLACEHOLDER_SVG = `data:image/svg+xml;utf8,${encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 500" preserveAspectRatio="xMidYMid slice">
    <defs>
      <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stop-color="#FDF2F2"/>
        <stop offset="100%" stop-color="#F8E1E4"/>
      </linearGradient>
    </defs>
    <rect width="400" height="500" fill="url(#g)"/>
    <g fill="#C78A94" opacity="0.65" font-family="Georgia,serif">
      <text x="200" y="245" text-anchor="middle" font-size="34" font-style="italic">Flownté</text>
      <text x="200" y="278" text-anchor="middle" font-size="10" letter-spacing="4" font-family="system-ui">IMAGE COMING SOON</text>
    </g>
  </svg>`
)}`;

/**
 * <img> drop-in that swaps to a soft blush "Image coming soon" placeholder
 * when the source 404s or fails to load. Keeps storefront clean even if a
 * product image URL is broken (e.g. missing /uploads/ file after a redeploy).
 */
export default function SafeImg({
  src,
  alt = "",
  fallback = PLACEHOLDER_SVG,
  className = "",
  ...rest
}) {
  const [current, setCurrent] = useState(src || fallback);

  useEffect(() => {
    setCurrent(src || fallback);
  }, [src, fallback]);

  return (
    <img
      src={current}
      alt={alt}
      loading="lazy"
      onError={() => {
        if (current !== fallback) setCurrent(fallback);
      }}
      className={className}
      {...rest}
    />
  );
}
